export default [
  {
    icon: 'HomeIcon',
    title: 'หน้าแรก',
    route: 'lobby'
  },
  {
    icon: 'DollarSignIcon',
    title: 'ฝาก',
    route: 'deposit'
  },
  {
    icon: 'SmileIcon',
    title: 'ถอน',
    route: 'withdraw'
  },
  {
    icon: 'StarIcon',
    title: 'โปรโมชั่น',
    route: 'promotion'
  },
  {
    icon: 'PackageIcon',
    title: 'รับเครดิตเงินคืน',
    route: 'cashback'
  }
  // {
  //   icon: 'SettingsIcon',
  //   title: 'ตั้งค่า',
  //   route: 'setting'
  // }
]
